import { CodeListItem } from 'app/area/codetable/list/types-store';
import { RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';
import {
  getAxisDescription, mapToRiskMatrixDefinition
} from 'app/area/risk-matrix-administration/mappers/map-to-risk-matrix-definition';
import { RiskMatrixAxes, RiskMatrixCell } from 'app/area/risk-matrix-administration/types-store';
import { AxisLabelMode, RiskMatrix } from 'app/components/risk-matrix';
import { ComplexValue } from 'app/types-shared';
import React from 'react';

interface MatrixProps {
  onSelectedCell: (xAxisItemIndex: number, yAxisItemIndex: number) => void;
  axes: RiskMatrixAxes;
  cells: RiskMatrixCell[];
  translation: RiskMatrixTranslation;
  riskAreas: CodeListItem[];
  thirdAxisItem?: ComplexValue<number>;
}

export const Matrix = ({ axes, cells, riskAreas, translation, onSelectedCell, thirdAxisItem }: MatrixProps) =>
  <RiskMatrix
    className={undefined}
    componentId="risk_matrix"
    onSelectedXChanged={undefined}
    onSelectedYChanged={undefined}
    onSelectedCell={onSelectedCell}
    optionToCellValue={undefined}
    preselectedValues={[]}
    displayAllValues={true}
    readOnly={false}
    riskMatrixDefinition={mapToRiskMatrixDefinition({ axes, cells, riskAreas, translation, thirdAxisItem })}
    xAxisLabelMode={AxisLabelMode.all}
    yAxisLabelMode={AxisLabelMode.all}
    textXAxisTitle={getAxisDescription(axes[0]?.codetableId, translation)}
    textYAxisTitle={getAxisDescription(axes[1]?.codetableId, translation)}
    label={{ visible: false }}
  />;
